import { BaseManagementBloc } from "./bloc.base";

export class CloudManagementBloc extends BaseManagementBloc {
}

